<template>
  <div class="languagekey-bd bd">
    <div class="aside">
      <div class="title">
        <i class="icon icon-langset"></i>
        <span>{{ $t('base_languageKey.duo_yu_yan_lie_biao') }}</span>
      </div>
      <div class="search" v-if="funcView.key_group_list">
        <custom-select
          isDefault
          v-model="appId"
          url="AppMenu"
          :clearable="false"
          :props="{ label: 'appName', value: 'appId' }"
          :placeholder="$t('Common.com_please_select')"
          width="100%"
          style="margin-bottom: 14px; vertical-align: top"
          @change="selectApp"
        ></custom-select>
        <custom-select
          isDefault
          v-model="langCode"
          code="language_type"
          :clearable="false"
          :props="{ label: 'name', value: 'value' }"
          :placeholder="$t('Common.com_please_select')"
          width="100%"
          style="margin-bottom: 14px; vertical-align: top"
          @change="selectLangCode"
        ></custom-select>
      </div>
      <div class="tree" v-if="funcView.language_key_menu">
        <el-collapse v-model="collapse" accordion @change="collapseChange">
          <el-collapse-item :title="item.name" :name="index" v-for="(item, index) in appTree" :key="index">
            <template v-if="item.value === 'system_platform'">
              <div class="search" style="margin: 0px">
                <div class="ub" style="margin-bottom: 12px">
                  <div class="ub-f1" style="margin-right: 8px">
                    <el-input :placeholder="$t('base_languageKey.fen_zu_ming_cheng')" v-model="item.keyWords" @input="filterTree($event, index)" clearable></el-input>
                  </div>
                  <add-button v-if="funcView.key_group_add" @click="addLanguageKeyGroup()"></add-button>
                </div>
              </div>
              <el-tree
                ref="tree"
                :data="item.children"
                :props="treeProps"
                node-key="id"
                :highlight-current="true"
                :default-expanded-keys="expandedKeys"
                :expand-on-click-node="false"
                @node-click="handleNodeClick"
                :filter-node-method="filterNode"
              >
                <!-- 点击 -->
                <span class="tree-item" v-if="data.id === langData.id" slot-scope="{ node, data }">
                  <span class="line1">{{ node.label }}</span>
                  <span>
                    <el-button type="text" @click="addLanguageKeyGroup(data)" v-if="funcView.key_group_add" size="mini">
                      <i class="icon icon-add"></i>
                    </el-button>
                    <el-button type="text" @click="editLanguageKeyGroup(data)" v-if="funcView.key_group_update && data.parentId !== '0'" size="mini">
                      <i class="icon icon-bianji"></i>
                    </el-button>
                    <el-button type="text" @click="deleteProtocolParamGroup(data)" v-if="funcView.key_group_delete && data.parentId !== '0'" size="mini">
                      <i class="icon icon-shanchu"></i>
                    </el-button>
                  </span>
                </span>
                <!-- 默认 -->
                <span class="tree-item" v-else slot-scope="{ data }">
                  <span class="line1">{{ data.name }}</span>
                </span>
              </el-tree>
            </template>
            <template v-else>
              <el-input style="margin-bottom: 12px" :placeholder="$t('base_languageKey.fen_zu_ming_cheng')" v-model="item.keyWords" @input="filterTree($event, index)" clearable></el-input>
              <el-tree
                ref="tree"
                :data="item.children"
                :props="treeProps"
                node-key="id"
                :highlight-current="true"
                :default-expanded-keys="expandedKeys"
                :expand-on-click-node="false"
                @node-click="handleNodeClick"
                :filter-node-method="filterNode"
              >
                <span class="tree-item" slot-scope="{ data }">
                  <span class="line1">{{ data.name }}</span>
                </span>
              </el-tree>
            </template>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <div class="section" v-if="funcView.language_key_list">
      <div class="section-info">
        <table>
          <tr>
            <th style="width: 130px">{{ $t('base_languageKey.suo_shu_ying_yong') }}</th>
            <th style="width: 210px">{{ $t('base_languageKey.jian_lei_xing') }}</th>
            <th>{{ $t('base_languageKey.fen_zu_ming_cheng') }}</th>
          </tr>
          <tr>
            <td>{{ appName }}</td>
            <td>{{ parentType }}</td>
            <td>{{ parentName }}</td>
          </tr>
        </table>
      </div>
      <div class="search-hd">
        <el-form :inline="true">
          <el-form-item>
            <el-button type="primary" icon="el-icon-plus" @click="addLangItem()" :disabled="showCollapse === null || JSON.stringify(langData) === '{}'" v-if="funcView.language_key_add">
              {{ $t('Common.com_add')}}
            </el-button>
          </el-form-item>
          <!-- 配置项 -->
          <el-form-item style="float: right; margin-right: 0">
            <custom-column ref="column"></custom-column>
          </el-form-item>
          <!-- 搜索栏 -->
          <el-form-item style="float: right">
            <search-input v-model="formSearch.search" :placeholder="$t('base_languageKey.jmcdmmrz')" @fetch="onPageChange({ page: 1 })"></search-input>
          </el-form-item>
          <!-- 选择下拉 -->
          <el-form-item style="float: right">
            <custom-select
              v-model="formSearch.translateStatus"
              code="bas_translate_status"
              :placeholder="$t('base_languageKey.shi_fou_fan_yi')"
              width="120px"
              @change="onPageChange({ page: 1 })"
            ></custom-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-bd">
        <custom-table tableCode="langKeyConfig" :data="langItemList" @column="setColumn" @filter="filterChange" @sort="sortChange" height="100%">
          <template slot="action" slot-scope="scope">
            <el-button @click="editLangItem(scope.row)" type="text" size="mini" v-if="funcView.language_key_update">{{ $t('Common.com_edit') }}</el-button>
            <el-button @click="deleteLangItem(scope.row)" type="text" size="mini" v-if="funcView.language_key_delete">
              {{ $t('Common.com_delete')}}
              <!-- <span class="local-del" v-if="scope.row.localDelete">(本地已删除)</span> -->
            </el-button>
          </template>
        </custom-table>
      </div>
      <div class="table-page">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
    <!-- 编辑编辑弹窗 -->
    <lang-param-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="successTreeGroupLang"></lang-param-dialog>
    <!-- key分组弹窗 -->
    <lang-tree-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false" @success="successTreeGroupLang"></lang-tree-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import addButton from '@/components/addButton';
import langTreeDialog from './children/languageKey_tree_dialog';
import langParamDialog from './children/languageKey_param_dialog';

export default {
  name: 'languageKey',
  components: { langTreeDialog, langParamDialog, addButton },
  data() {
    return {
      collapse: '',
      appId: '',
      langCode: '',
      appTree: [],
      langData: {},
      expandedKeys: [],
      langKeyTypes: [],
      // 参数
      dialogVisible: false,
      dialogModel: {},
      // 树
      dialogVisible1: false,
      dialogModel1: {},

      dataTimes: [],
      formSearch: {
        keyId: '',
        langCode: '',
        keyTypeCode: '',
        startDate: '',
        endDate: '',
        translateStatus: '',
        search: '',
        pageSize: 50,
        pageNum: 1,
      },

      langItemList: [],
      totalRows: 0,
      isLoading: false,
      treeProps: {
        children: 'children',
        label: 'name',
      },
      // 当前被选的树
      protocolActive: {},
      // 右边显示
      appName: '',
      parentType: '',
      parentName: '',
      // 展开的
      showCollapse: null,
    };
  },
  mounted() {
    this.resetForm = JSON.stringify(this.form);
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getDictionary1();
    this.getFuncView();
  },
  methods: {
    // 选择平台
    selectApp: function (curApp) {
      this.appName = curApp.appName;
      const search = this.formSearch.search;
      const translateStatus = this.formSearch.translateStatus;
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.formSearch.search = search;
      this.formSearch.translateStatus = translateStatus;

      this.langItemList = [];
      this.dataTimes = [];
      this.totalRows = 0;
      this.appTree = [];
      this.langData = {};
      this.expandedKeys = [];
      this.collapse = '';
      this.getAppTree();
      if (this.appId && this.langCode) {
        this.onPageChange({ page: 1 });
      }
    },
    // 选择语言
    selectLangCode: function () {
      if (this.appId && this.langCode) {
        this.onPageChange({ page: 1 });
      }
    },
    // 获取列表
    getLangItemPage: function () {
      if (!this.appId || !this.langCode) {
        return;
      }
      this.formSearch.appId = this.appId;
      this.formSearch.langCode = this.langCode;
      this.formSearch.keyId = this.langData.id;
      this.formSearch.keyTypeCode = this.langData.value;
      this.isLoading = true;
      this.$getJSON(apis.LanguagePage, this.formSearch).then((res) => {
        this.isLoading = false;
        const list = res.data.list;
        this.langItemList = list;
        this.totalRows = res.data.total;
      });
    },
    // 下拉选择列表
    getDictionary1: function () {
      this.$getJSON(apis.DictionaryCode, {
        groupCodes: 'bas_lang_key_type',
      }).then((res) => {
        this.langKeyTypes = res.data.bas_lang_key_type || [];
      });
    },
    // 获取平台多语言树
    getAppTree: function () {
      this.$getJSON(apis.LanguageTree, { appId: this.appId }).then((res) => {
        const appTree = res.data || [];
        appTree.forEach((t) => {
          t.keyWords = '';
        });
        this.appTree = appTree;
        // 更新选择
        this.$nextTick(() => {
          // 有选中值并且展开
          if (this.langData.id && this.showCollapse !== null) {
            this.$refs.tree[this.showCollapse].setCurrentKey(this.langData.id);
          }
        });
      });
    },
    // 选中树字典项
    handleNodeClick: function (row) {
      this.expandedKeys = [row.id];
      this.langData = row;
      const search = this.formSearch.search;
      const translateStatus = this.formSearch.translateStatus;
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.formSearch.search = search;
      this.formSearch.translateStatus = translateStatus;
      this.appTree.forEach((item, index) => {
        this.$refs.tree[index].setCurrentKey(null);
        this.$refs.tree[index].setCurrentKey(this.langData.id);
      });
      this.getLangItemPage();
      if (row.parentId === '0') {
        this.parentName = row.name;
      } else {
        this.parentName = row.data.groupName;
      }
    },
    // 搜索过滤事件
    filterTree: function (value, index) {
      this.$refs.tree[index].filter(value);
    },
    // 搜索过滤
    filterNode: function (value, data) {
      if (!value) {
        return true;
      }
      return data.name.indexOf(value) !== -1;
    },
    // 表格项格式化
    formatLangKeyType: function (row, column) {
      const langKeyType = this.langKeyTypes.find(t => `${t.data.dicValue}` === `${row[column.property]}`) || { data: {} };
      return langKeyType.data.dicName;
    },
    // 所属key类型
    collapseChange: function (num) {
      // 收缩了
      if (num === '') {
        this.parentType = '';
        this.parentName = '';
        this.showCollapse = null;
        // 收缩 去除所有tree的选择
        // this.$refs.tree.setCurrentKey(this.expandedKeys[0]);
        // 关闭了 清除选中对象
        this.langData = {};
        // 更新选择
        this.$nextTick(() => {
          this.$refs.tree.forEach((item, index) => {
            this.$refs.tree[index].setCurrentKey(null);
          });
        });
      } else {
        this.showCollapse = num;
        // 展开的时候设置
        const parentType = this.appTree[num].name;
        this.parentType = parentType;
      }
    },
    // 添加分组
    addLanguageKeyGroup: function (data) {
      this.dialogModel1.type = 'add';
      this.dialogModel1.title = this.$t('base_languageKey.xin_zeng_fen_zu');
      this.dialogModel1.data = {
        appId: this.appId,
        appName: this.appName,
        parentId: data && data.id ? data.id : null,
      };
      this.dialogVisible1 = true;
    },
    // 编辑分组
    editLanguageKeyGroup: function (data) {
      this.dialogModel1.type = 'edit';
      this.dialogModel1.title = this.$t('base_languageKey.bian_ji_fen_zu');
      this.dialogModel1.data = {
        appName: this.appName,
        row: data.data,
      };
      this.dialogVisible1 = true;
    },
    // 删除分组  完成  //右边参数清空才可以删除
    deleteProtocolParamGroup: function (data) {
      this.$showConfirm(this.$t('base_languageKey.nqdyscxzdfzm'))
        .then(() => {
          this.$postJSON(`${apis.LanguageKeyGroupDelete}/${data.data.langKeyId}`).then(() => {
            this.expandedKeys = [data.parentId];
            // 树更新
            this.getAppTree();
            // 删除成功刷新右侧
            this.getLangItemPage();
          });
        })
        .catch(() => {});
    },
    // 添加 编辑分组成功的回调
    successTreeGroupLang() {
      this.getAppTree();
      this.getLangItemPage();
    },
    // 添加编辑
    addLangItem: function () {
      this.dialogModel.type = 'add';
      this.dialogModel.title = this.$t('base_languageKey.xin_zeng_duo_yu_yan');
      this.dialogModel.data = {
        appId: this.appId,
        appName: this.appName,
        parentId: this.langData.id || null,
        langKeyType: this.langData.value2,
        langKeyTypeOn: this.langData.value2 !== '4', // 只有系统菜单才能选择key类型
      };
      this.dialogVisible = true;
    },
    // 编辑编辑
    editLangItem: function (data) {
      this.dialogModel.type = 'edit';
      this.dialogModel.title = this.$t('base_languageKey.bian_ji_duo_yu_yan');
      this.dialogModel.data = {
        appName: this.appName,
        row: data,
      };
      this.dialogVisible = true;
    },
    // 删除
    deleteLangItem: function (data) {
      this.$showConfirm(this.$t('base_languageKey.nqdyscxzddyym'))
        .then(() => {
          this.$postJSON(`${apis.LanguageKeyLangDelete}/${data.langKeyId}`).then(() => {
            this.expandedKeys = [data.parentId];
            this.getAppTree();
            // 删除成功刷新右侧
            this.getLangItemPage();
          });
        })
        .catch(() => {});
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getLangItemPage();
    },
  },
};
</script>

<style lang="scss">
@import '@/style/mixin.scss';

.languagekey-bd {
  .aside {
    width: 270px !important;
    .search {
      margin-bottom: 0 !important;
    }
    .tit .el-input--mini .el-input__inner {
      @include color_main();
    }
    .el-collapse-item__content {
      padding-bottom: 0;
    }
    .el-collapse {
      border-top: none;
      border-bottom: none;
    }
    .el-collapse-item {
      margin-bottom: 10px;
      &.is-active .el-collapse-item__header {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
    .el-collapse-item__header {
      @include background_color_main();
      // background:rgba(68,133,166,1);
      border-radius: 2px 2px 0px 0px;
      // border:1px solid rgba(68,133,166,1);
      height: 30px;
      line-height: 30px;
      padding-left: 10px;
      color: #ffffff;
      font-size: 12px;
      font-weight: normal;
      border-radius: 2px;
      border-bottom: none;
    }
    .tree {
      background-color: transparent;
      overflow-y: inherit !important;
      .el-collapse {
        display: flex;
        flex-direction: column;
        height: 100%;
        .el-collapse-item.is-active {
          flex: 1;
          display: flex;
          flex-direction: column;
          overflow-y: auto;
          // overflow-y:inherit !important;
          // margin-bottom:10px;
          .el-collapse-item__wrap {
            flex: 1;
            overflow-y: auto;
            border: 1px solid rgba(0, 0, 0, 0.1);
            margin-top: 10px;
            border-radius: 2px;
          }
        }
      }
    }
    .el-collapse-item__wrap {
      padding: 14px;
      border-bottom: none;
    }
    .tree .el-tree-node__content {
      height: 32px !important;
      line-height: 32px !important;
    }
  }
  .section {
    margin-left: 270px !important ;
    .local-del {
      color: red;
    }
  }
}
</style>
